module.exports = __webpack_public_path__ + "img/icons/ico-inst-color.svg";


//////////////////
// WEBPACK FOOTER
// ./img/icons/ico-inst-color.svg
// module id = 196
// module chunks = 13